const BERLIN_LOCALE = 'de-DE';
const BERLIN_TIMEZONE = 'Europe/Berlin';

function parsePdfDateValue(value) {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) {
      return null;
    }

    const sqlDateTimeMatch = trimmed.match(/^(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2})(?::(\d{2})(\.\d{1,3})?)?$/);
    if (sqlDateTimeMatch) {
      const [, datePart, timePart, seconds = '00', fractional = ''] = sqlDateTimeMatch;
      const parsedSqlDate = new Date(`${datePart}T${timePart}:${seconds}${fractional}Z`);
      return Number.isNaN(parsedSqlDate.getTime()) ? null : parsedSqlDate;
    }

    const parsedDate = new Date(trimmed);
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
  }

  const parsedDate = new Date(value);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
}

export function formatBerlinDate(value, { fallback = '-' } = {}) {
  const date = parsePdfDateValue(value);
  if (!date) {
    return fallback;
  }

  return new Intl.DateTimeFormat(BERLIN_LOCALE, {
    timeZone: BERLIN_TIMEZONE,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  }).format(date);
}

export function formatBerlinDateTime(value, { fallback = '-' } = {}) {
  const date = parsePdfDateValue(value);
  if (!date) {
    return fallback;
  }

  return new Intl.DateTimeFormat(BERLIN_LOCALE, {
    timeZone: BERLIN_TIMEZONE,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(date);
}